import type { GetSyncStatusResponse } from '@this/shared/dist/apis/serviceaddinapi/common.js';
import { useTsRest } from '../context/ts-rest.js';

export function useSyncStatus(): GetSyncStatusResponse | undefined {
    const tsr = useTsRest();

    const { data } = tsr.common.getSyncStatus.useQuery({
        queryKey: ['common', 'getSyncStatus'],
        refetchInterval: 20000, // Poll every 20 seconds
    });

    return data?.body;
}
